import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasProgramInstanceSchema = withDefaults({
  type: 'tas-program-instance',
  objectExtensions: ['tas-program-instance'],
  traits: ['commentable'],
  fields: [
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'fields',
    },
    {
      kind: 'attribute',
      name: 'customFields',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'migrationApplicationId',
    },
    {
      kind: 'attribute',
      name: 'programApproval',
    },
    {
      kind: 'attribute',
      name: 'completionApproval',
    },
    {
      kind: 'attribute',
      name: 'withdrawalApproval',
    },
    {
      kind: 'attribute',
      name: 'isTrial',
    },
    {
      kind: 'attribute',
      name: 'history',
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: 'tasProgramInstances',
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramTemplate',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: 'tasProgramInstances',
      },
    },
    {
      kind: 'belongsTo',
      name: 'dependent',
      type: 'dependent',
      options: {
        async: false,
        inverse: 'tasProgramInstances',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasApplications',
      type: 'tas-application',
      options: {
        async: false,
        inverse: 'tasProgramInstance',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasAssets',
      type: 'tas-asset',
      options: {
        async: false,
        inverse: 'tasProgramInstances',
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasProgramInstanceSchema;
